// Custom components
import React, { useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

function InputField(props) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    error,
    disabled,
    onChange,
  } = props;

  const [passwordState, setPasswordState] = useState(false);

  const changePasswordState = (e) => {
    e.preventDefault();

    setPasswordState(!passwordState);
  };

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      {type === "password" ? (
        <div className="relative">
          <input
            type={passwordState ? "text" : "password"}
            id={id}
            placeholder={placeholder}
            disabled={disabled}
            onChange={onChange}
            className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${
              disabled === true
                ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
                : error
                ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
                : state === "success"
                ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
                : "border-gray-200 dark:!border-white/10 dark:text-white"
            }`}
          />
          <button
            onClick={changePasswordState}
            className="absolute top-1/2 right-4 -translate-y-1/2 transform"
          >
            {passwordState ? (
              <FaRegEye className="cursor-pointer text-lg text-gray-500 dark:text-gray-400" />
            ) : (
              <FaRegEyeSlash className="cursor-pointer text-lg text-gray-500 dark:text-gray-400" />
            )}
          </button>
        </div>
      ) : (
        <input
          disabled={disabled}
          type={type}
          id={id}
          placeholder={placeholder}
          onChange={onChange}
          className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${
            disabled === true
              ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
              : error
              ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
              : state === "success"
              ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
              : "border-gray-200 dark:!border-white/10 dark:text-white"
          }`}
        />
      )}

      {/* Error message */}
      {error && (
        <p className="mt-1 text-xs text-red-500 ms-2 dark:text-red-400">
          This field is required
        </p>
      )}
    </div>
  );
}

export default InputField;
